import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { ApplyPipeModule, SpinnerModule } from 'ngx-zcs-components';
import { MatBadgeModule } from '@angular/material/badge';
import { IonicModule } from '@ionic/angular';

import { PlantCardOverviewComponent } from './plant-card-overview.component';
import { ComponentsModule } from '../components/components.module';

@NgModule({
    declarations: [
      PlantCardOverviewComponent,
    ],
    imports: [
      ApplyPipeModule,
      CommonModule,
      ComponentsModule,
      IonicModule,
      MatBadgeModule,
      MatIconModule,
      MatTooltipModule,
      SpinnerModule,
    ],
    exports: [
      PlantCardOverviewComponent,
    ],
})
export class PlantCardOverviewModule { }
